import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUserProjectsLimitCount } from '../../../store/modules/auth/selectors';
import { projectSelectors } from '../../../store/modules/project';
import { userSelectors } from '../../../store/modules/user';

const useCanOpenEditor = () => {
  const profile = useSelector(userSelectors.selectUserProfile);
  const projectCount = useSelector(projectSelectors.selectProjectsCount);
  const [canOpenEditor, setCanOpenEditor] = useState(true);

  useEffect(() => {
    if (profile) {
      const userLimitCount = getUserProjectsLimitCount(profile);
      setCanOpenEditor(projectCount < userLimitCount);
    }
  }, [profile?.userId]);

  return canOpenEditor;
};

export default useCanOpenEditor;
